import { render, staticRenderFns } from "./PackingLabelPdf.vue?vue&type=template&id=ecb5e1ac&scoped=true&"
import script from "./PackingLabelPdf.vue?vue&type=script&lang=js&"
export * from "./PackingLabelPdf.vue?vue&type=script&lang=js&"
import style0 from "./PackingLabelPdf.vue?vue&type=style&index=0&id=ecb5e1ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb5e1ac",
  null
  
)

export default component.exports